export default "__VITE_ASSET__D4EWcxDY__"